import React, { Fragment, useRef, useEffect, useState } from 'react'
import parse from "html-react-parser"
import GoogleMap from "../maps/google-map"
import moment from "moment";
import PaymentCard from '../PaymentCard/PaymentCard'
import './PlanOverview.scss'
import { Link } from 'gatsby'
import Share from "../Share/share"
import { Capitalize, numberFormat } from '../../common/site/utils';
import HolidayContactDetails from '../ContactDetails/HolidayContactDetails';
import ContactDetails from '../ContactDetails/PropertyContactDetails';
import PropertyPermitInfo from '../PropertyPermitInfo/PropertyPermitInfo';
import { AreaguideBaseURL } from "../../common/site/utils"
import { useQuery } from "@apollo/client"
import gql from "graphql-tag"
const PlanOverview = (props) => {

    const GET_AREA_GUIDE = gql`
    query GetAreaGuide($URL: String) {
        areaGuides(where: { slug: $URL }) {
            Content
      }
    }
  `
    const { loading, error, data } = useQuery(GET_AREA_GUIDE, {
      variables: { URL: props.area?.toLowerCase()?.replace(/ /g, '-') },
    })
  
    const [readMore, setReadMore] = useState(true);

    const showButton = props.long_description.length > 400

    const [showReadMore, setShowReadMore] = useState(showButton);
    const elementRef = useRef();
    const paymentPlanData = [{
        installation: "Down Payment — 10%",
        installationInfo: "On booking"
      },
      {
        installation: "1st Instalment — 10%",
        installationInfo: "Within 2 months from booking date"
      },
      {
        installation: "2nd Instalment — 10%",
        installationInfo: "Within 6 months from 1st Instalment date"
      },
      {
        installation: "3nd Instalment — 10%",
        installationInfo: "On 10% Construction completion*"
      },
      {
        installation: "4th Instalment — 20%",
        installationInfo: "On 70% Construction completion*"
      },
      {
        installation: "5th Instalment — 40%",
        installationInfo: "On completion | 100% Construction completion*"
      }
      ]
    useEffect(() => {
        const divElement = elementRef?.current;
        const divElementHeight = divElement?.clientHeight;
        if (divElementHeight < 140) {
            setShowReadMore(false);
            setReadMore(false);
        }
    }, []);

    let isHolidayLets = props.department === "short-lettings"
    const bedlist = [1,2,3,4,5,6,7,8,9,10]
    return (
        <section className='plan-overview'>
            <div className='plan-head' id="property-overview">
                {props.offPlan ?
                    <div className='details_content off_plan'>
                        <h1>{props.extra?.off_Plan_Project_Building_Name} </h1>
                        <div className='share-parent'>
                            <h3><b>{props?.area}</b></h3>
                            <Share
                                iconclass="icon-share"
                            />
                        </div>
                    </div>
                    : 
                    <div className='details_content residential'>
                        {(props.price && numberFormat(props.price) != 0) ?
                        <h2>AED {numberFormat(props.price)} <span>{isHolidayLets ? props?.price_qualifier : null}</span></h2>
                        : ""
                        }
                        <h3><b>{props.display_address}</b></h3>
                        <div className='share-parent'>
                        <h3>{props.title}</h3>
                        <Share
                            iconclass="icon-share"
                        />
                        </div>
                    </div>
                }
            </div>
            {props.offPlan &&
                <>
                    <div className='__divider'></div>
                    <div className='plan-content dev-content'>
                        <div className='lft-data'>
                            <h2>Prices from:</h2>
                            <span className='plan-description'>AED {numberFormat(props.price)}</span>
                        </div>
                        <div className='rgt-data'>
                            <h2>Types:</h2>
                            <span className='plan-description'>
                                {bedlist?.map((item, i) => {
                                    return(
                                        <>
                                        {props.extra?.off_Plan_Minimum_Bedrooms <= item && props.extra?.off_Plan_Maximum_Bedrooms >= item ? 
                                    <>{props.extra?.off_Plan_Maximum_Bedrooms === item ? `&  ${item} ` : `${item} `}</>    
                                    : null}
                                        </>
                                    )
                                })}
                                 Bedroom Apartments</span>
                        </div>
                    </div>
                    <div className='plan-content'>
                        {props?.developer &&
                            <div className='lft-data'>
                                <div className='__divider'></div>
                                <h2>Developer:</h2>
                                <span className='plan-description'>{props?.developer}</span>
                            </div>
                        }
                        {props?.completion_date &&
                            <div className='rgt-data'>
                                <div className='__divider'></div>
                                <h2>Completion Date:</h2>
                                <span className='plan-description'>{moment(props?.completion_date).format('MMMM YYYY')}</span>
                            </div>
                        }
                        {props.description &&
                            <p>{parse(props.description)}</p>
                        }
                    </div>
                </>
            }
            {props?.accomadation_summary?.length > 0 && !props.offPlan && !isHolidayLets &&
                <>
                    <div className='__divider'></div>
                    <div className='key-features-section'>
                        <h3>Key Features</h3>
                        <ul>
                            {props.accomadation_summary.map((data) => {
                                return (
                                    <li>{Capitalize(data)}</li>
                                )
                            })}
                        </ul>
                    </div>
                </>
            }
            {props.long_description && !props.offPlan &&
                <>
                    <div className='__divider'></div>
                    <div className={`plan-content last full-description ${!readMore ? 'full-height' : ''}`}>
                        <h3 className='detail-title-head'>Description</h3>
                        <p>{parse(props.long_description)}</p>
                        {showReadMore && (
                            <div className="read-more">
                                <span onClick={() => setReadMore(!readMore)}>Show {readMore ? 'More' : 'Less'}</span>
                            </div>
                        )}
                    </div>
                </>
            }
            {props.offPlan &&
                <>
                    <div className='__divider'></div>
                    <div className='payment-wrappr' id="payment-plan">
                        <h4>Payment Plan</h4>
                        <p>Contact us to know more about our attractive payment plans and choose the one that best fits your needs. *Estimated construction completion date.</p>
                        <PaymentCard paymentPlanData={paymentPlanData} />
                    </div>
                </>
            }            
            {props?.extra?.qr_code &&
            <>
                <div className='__divider'></div>
                <div className='property-permit-info-box'>
                    <PropertyPermitInfo qrUrl={props?.extra?.qr_code} permitNumber={props?.extra?.rera_permit_number} />
                </div>
            </>
            }
            {!props.offPlan && 
                <>
                    <div className='__divider d-block d-xl-none'></div>
                    <div className='contact-box d-block d-xl-none'>
                        {props.department === "residential" ? 
                            <ContactDetails {...props} /> :
                        props.department === "short-lettings" ?
                            <HolidayContactDetails {...props} /> :
                        ""}
                    </div>
                </>
            }
            {props.latitude && props.longitude ?
                <>
                    <div className='__divider'></div>
                    <div className='plan-content last ' id="property-location">
                        <h3 className='detail-title-head map-head'>Property Location</h3>
                        <GoogleMap lat={props.latitude} lng={props.longitude} height={"440px"} />
                    </div>
                </>
            : ""
            }
            {data?.areaGuides?.length > 0 && 
                <>
                    {/* <div className='__divider'></div> */}
                    <div
                        className={`plan-content last area-guide full-description ${!readMore ? 'full-height' : ''}`}
                        ref={elementRef}
                    >
                        <h3 className='detail-title-head'>About {props.area}</h3>
                        <p>{parse(data?.areaGuides[0]?.Content)}</p>
                        {showReadMore && (
                            <div className="read-more">
                                <span>
                                <Link to={`${AreaguideBaseURL}${props.area?.toLowerCase()?.replace(/ /g, '-')}/`}>
                                <span>
                                    Show {readMore ? 'More' : 'Less'}
                                    </span>   
                                </Link>
                                </span>
                            </div>
                        )}
                    </div>
                </>
            }
            {props.offPlan && 
                <>
                    <div className='__divider d-block d-xl-none'></div>
                    <div className='contact-box d-block d-xl-none mt-4'>
                        {props.department === "residential" ? 
                            <ContactDetails {...props} /> :
                        ""}
                    </div>
                </>
            }
        </section >
    )
}

export default PlanOverview